import React, { useEffect, useState } from "react";
import axios from "axios";
import { IoMdArrowDroprightCircle } from "react-icons/io";
import { Main } from "./style";
const MainElement = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        "https://gist.githubusercontent.com/rodrigoant/f906faf135145c885f3bcc4e1c944571/raw/8c02942c371eae3e7a7124f891dd473543db9ad0"
      )
      .then(result => setData(result.data));
  }, []);

  return (
    <Main>
      {data.map(({ id, name, job, description, image, link }) => (
        <section
          style={{ backgroundColor: id % 2 ? "#f0f0f0" : "#f9f9f9" }}
          key={id}
        >
          <div className="container">
            <div className="left-container">
              <a title={name} target="_blank" href={link}>
                <img src={image} alt={name} title={name} />
              </a>
            </div>
            <div className="right-container">
              <div className="client-name">{name}</div>
              <div className="client-info">{job}</div>
              <div className="client-desc">{description}</div>
              <div className="client-link">
                <a title={name} target="_blank" href={link}>
                  <IoMdArrowDroprightCircle />
                  Acesse o projeto
                </a>
              </div>
            </div>
          </div>
        </section>
      ))}
    </Main>
  );
};

export default MainElement;



// WEBPACK FOOTER //
// ./src/components/Main/index.js